import {REST_METHODS} from '@/src/app/constants/api';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const VACANCIES_PER_PAGE = 10;

const fetchVacanciesForUnitedTab = ({searchQuery, locale}) => {
  const isAuthorized = getAuthorizationToken();
  const fetchMethod = isAuthorized ? authorizedFetch : unauthorizedFetch;

  // @ts-ignore
  return fetchMethod({
    method: REST_METHODS.GET,
    path: '/api/v1/job_portal/vacancies_search',
    queryParams: [
      {
        name: SEARCH_FILTERS.LANGUAGE,
        value: locale,
      },
      {
        name: SEARCH_FILTERS.SEARCH,
        value: searchQuery,
      },
      {
        name: SEARCH_FILTERS.PER_PAGE,
        value: VACANCIES_PER_PAGE,
      },
    ],
  });
};

export default fetchVacanciesForUnitedTab;
